<template>
  <Badge class="filter-badge lisaui:cursor-pointer">
    <i v-if="filter.isNegated" class="filter-badge-prefix fas fa-not-equal" />
    <span class="filter-badge-content">
      <slot />
    </span>
    <LISAButton
      class="filter-badge-remove"
      size="sm"
      variant="neutral"
      text
      icon="fas fa-times"
      aria-label="Filter entfernen"
      @click.stop="$emit('remove')"
    />
  </Badge>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import Badge from "@/components/badges/BadgeComponent.vue";
import type { ActionFilter, EventFilter } from "../../FilterTypes";
import { LISAButton } from "@fi-solutions/lisa-ui";

defineProps({
  filter: {
    type: Object as PropType<EventFilter | ActionFilter>,
    required: true,
  },
});
defineEmits(["remove"]);
</script>

<style lang="scss" scoped>
.filter-badge {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
}

.filter-badge-prefix,
.filter-badge-remove {
  flex: 0 0 auto;
}

.filter-badge-content {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-badge-remove {
  color: inherit;
  min-width: 1.5rem;
  min-height: 1.5rem;
  padding: 0;
  opacity: 0.65;
}

.filter-badge-remove:hover {
  opacity: 1;
}
</style>
